import { lazy } from 'react';

export const FakesAddPage = lazy(() => import('./AddPage/AddPage'));
export const FakesEditPage = lazy(() => import('./EditPage/EditPage'));
export const FakesViewPage = lazy(() => import('./ViewPage/ViewPage'));
